import React, { useState } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import { IconButton } from '@material-ui/core';
import ErrorAwareTextField from "../../../../common/inputfields/ErrorAwareTextField";

function ProjectPhaseDescription({ phase = null }) {
    const [isModify, setIsModify] = useState(false);
    const [description, setDescription] = useState(phase.comment || "");

    const handleApply = async () => {
        console.log(phase);
        console.log(description);
        try {
            const payload = {
                privateId: phase.privateId,
                comment: description
            };
            console.log(payload);
            await axios.patch("/api/projectphase/modifycomment", payload);
            // notify app to refresh project detail and reopen the same phase accordion
            window.dispatchEvent(new CustomEvent("projectphase:nextApplied", { detail: { privateId: phase.privateId } }));
        } catch (err) {
            // handle error (could add toast)
            console.error("Failed to apply next project phase", err);
        } finally {
            setIsModify(false);
        }
    };

    const handleCancel = () => {
        setIsModify(false);
        setDescription(phase.comment || "");
        console.log(phase);
    }

    return (
        <>
            <div className="section-title">
                Ütem leírása
                <IconButton
                    size="small"
                    onClick={(e) => setIsModify(true)}
                    aria-label="Lehetséges műveletek"
                >
                    <EditIcon fontSize="small" color="primary" />
                </IconButton>
            </div>
            <div className="section-content">
                {/* <p className="description-text">{phase.comment}</p> */}

                {isModify ?
                    <>
                        <ErrorAwareTextField
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            multiline
                            rows={3}
                        />
                        <Button onClick={handleCancel}>Mégse</Button>
                        <Button color="primary" variant="contained" onClick={handleApply}>Alkalmaz</Button>
                    </>
                    :
                    <p>{phase.comment}</p>
                }
            </div>
        </>
    )
}
export default ProjectPhaseDescription